import { render, staticRenderFns } from "./SelectTransactionType.vue?vue&type=template&id=c72695be"
import script from "./SelectTransactionType.vue?vue&type=script&lang=js"
export * from "./SelectTransactionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72695be')) {
      api.createRecord('c72695be', component.options)
    } else {
      api.reload('c72695be', component.options)
    }
    module.hot.accept("./SelectTransactionType.vue?vue&type=template&id=c72695be", function () {
      api.rerender('c72695be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/widgets/SelectTransactionType.vue"
export default component.exports